import { createRoot } from "react-dom/client";
import "regenerator-runtime/runtime";

import "config/sentry";
import "config/i18n";

import "assets/styles/styles.css";
import "react-day-picker/style.css";

import App from "./App";
import { AppProviders } from "./AppProviders";
import { CALCULATOR_TYPES } from "constants/calculator";


interface WidgetOptions {
  type?: typeof CALCULATOR_TYPES;
  [key: string]: any;
}

function initWidget(selector: string, options?: WidgetOptions) {
  try {
    console.log("Initializing widget with selector:", selector, "options:", options);

    const container = document.querySelector(selector);
    if (!container) {
      console.error(`Element "${selector}" not found`);
      return;
    }

    console.log("Container found:", container);

    const root = createRoot(container as HTMLElement);
    root.render(
      <AppProviders>
        <App options={options} />
      </AppProviders>
    );

    console.log("Widget rendered successfully");
  } catch (error) {
    console.error("Error initializing widget:", error);
  }
}

const MyWidget = {
  init: initWidget,
};

export default MyWidget;

if (typeof window !== "undefined") {
  (window as any).MyWidget = MyWidget;
  console.log("MyWidget loaded and ready");
}
